import { withAlignment } from '@skyscanner/backpack-web/bpk-component-icon';
import CafeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/cafe';
import FamilyIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/family';
import HotelsPetsAllowedIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels--pets-allowed';
import PriceIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/price-tag';
import TimeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/time';
import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import {
  BpkTableRow,
  BpkTableCell,
  BpkTableHeadCell,
} from '@skyscanner/backpack-web/bpk-component-table';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';
import {
  iconSizeLg,
  lineHeightBase,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import type { Nullable } from '@shared/types/utils';

import STYLES from './Snippet.module.scss';

const iconsMap = {
  cafe: withAlignment(CafeIcon, lineHeightBase, iconSizeLg),
  time: withAlignment(TimeIcon, lineHeightBase, iconSizeLg),
  hotelsPetsAllowed: withAlignment(
    HotelsPetsAllowedIcon,
    lineHeightBase,
    iconSizeLg,
  ),
  family: withAlignment(FamilyIcon, lineHeightBase, iconSizeLg),
  price: withAlignment(PriceIcon, lineHeightBase, iconSizeLg),
};

const cls = cssModules(STYLES);
type IconName = keyof typeof iconsMap;

export type SnippetProps = {
  ariaText?: Nullable<string>;
  icon: IconName;
  label: string;
  linkUrl?: string;
  titleData?: { [key: string]: any };
  value?: string | string[] | number | null;
};

const Snippet = ({
  ariaText,
  icon,
  label,
  linkUrl,
  titleData = {},
  value,
}: SnippetProps) => {
  const Icon = iconsMap[icon];

  return (
    <BpkTableRow className={cls('Snippet')}>
      <BpkTableHeadCell className={cls('Snippet__row')}>
        <div className={cls('Snippet__icon')}>{Icon && <Icon />}</div>
        <BpkText
          tagName="span"
          className={cls('Snippet__label')}
          textStyle={TEXT_STYLES.bodyDefault}
          color={TEXT_COLORS.textPrimary}
        >
          {label}
        </BpkText>
      </BpkTableHeadCell>
      <BpkTableCell className={cls('Snippet__row')}>
        {linkUrl ? (
          <BpkLink
            href={linkUrl}
            rel="nofollow"
            aria-label={ariaText}
            className={cls('Snippet__clickAndValueLink')}
            {...titleData}
          >
            {value}
          </BpkLink>
        ) : (
          <BpkText
            tagName="span"
            textStyle={TEXT_STYLES.heading4}
            aria-label={ariaText}
            className={cls('Snippet__clickAndValue')}
            color={TEXT_COLORS.textPrimary}
            {...titleData}
          >
            {value}
          </BpkText>
        )}
      </BpkTableCell>
    </BpkTableRow>
  );
};

export default Snippet;
